/**
 * EDC REST API
 * EDC REST APIs - merged by OpenApiMerger
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Injectable }                      from '@angular/core';
import { HttpResponse, HttpEvent, HttpContext, HttpContextToken, HttpHeaders }              from '@angular/common/http';
import { Observable, from }                                        from 'rxjs';
import {EdcConnectorClient} from "@think-it-labs/edc-connector-client";
import { TransferProcessState, TransferProcess, TransferProcessInput, QuerySpec, IdResponse } from "../model";
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from 'src/modules/app/app-config.service';

// Token de contexto para desactivar interceptores de Keycloak
export const SKIP_KEYCLOAK_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export interface EdrDataAddress {
    "@type": string;
    type: string;
    endpoint: string;
    authType: string;
    endpointType: string;
    authorization: string;
    "@context": {
        "@vocab": string;
        "edc": string;
        "odrl": string;
    };
}


@Injectable({
  providedIn: 'root'
})
export class TransferProcessService {
    private transferProcessService = this.edcConnectorClient.management.transferProcesses;
    constructor(
      private appConfigService: AppConfigService,
      private edcConnectorClient: EdcConnectorClient,
      private http: HttpClient) {}

    /**
     * Requests aborting the transfer process. Due to the asynchronous nature of transfers, a successful response only indicates that the request was successfully received. Clients must poll the /{id}/state endpoint to track the state.
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cancelTransferProcess(id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any>;
    public cancelTransferProcess(id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<any>>;
    public cancelTransferProcess(id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<any>>;
    public cancelTransferProcess(id: string): Observable<any> {
        return from(this.transferProcessService.terminate(id, "Call by DataDashboard."));
    }

    /**
     * Requests the deprovisioning of resources associated with a transfer process. Due to the asynchronous nature of transfers, a successful response only indicates that the request was successfully received. This may take a long time, so clients must poll the /{id}/state endpoint to track the state.
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deprovisionTransferProcess(id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any>;
    public deprovisionTransferProcess(id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<any>>;
    public deprovisionTransferProcess(id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<any>>;
    public deprovisionTransferProcess(id: string): Observable<any> {
      return from(this.transferProcessService.deprovision(id))
    }

    /**
     * Gets an transfer process with the given ID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTransferProcess(id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<TransferProcess>;
    public getTransferProcess(id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<TransferProcess>>;
    public getTransferProcess(id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<TransferProcess>>;
    public getTransferProcess(id: string): Observable<any> {
        return from(this.transferProcessService.get(id))
    }

    /**
     * Gets the state of a transfer process with the given ID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTransferProcessState(id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<TransferProcessState>;
    public getTransferProcessState(id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<TransferProcessState>>;
    public getTransferProcessState(id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<TransferProcessState>>;
    public getTransferProcessState(id: string): Observable<any> {
        return from(this.transferProcessService.getState(id))
    }

    /**
     * Initiates a data transfer with the given parameters. Please note that successfully invoking this endpoint only means that the transfer was initiated. Clients must poll the /{id}/state endpoint to track the state
     * @param transferRequestInput
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public initiateTransfer(transferRequestInput: TransferProcessInput, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<IdResponse>;
    public initiateTransfer(transferRequestInput: TransferProcessInput, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<IdResponse>>;
    public initiateTransfer(transferRequestInput: TransferProcessInput, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<IdResponse>>;
    public initiateTransfer(transferRequestInput: TransferProcessInput): Observable<any> {
      return from(this.transferProcessService.initiate(transferRequestInput))
    }

    /**
     * Returns all transfer process according to a query
     * @param querySpec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public queryAllTransferProcesses(querySpec?: QuerySpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<TransferProcess>>;
    public queryAllTransferProcesses(querySpec?: QuerySpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<TransferProcess>>>;
    public queryAllTransferProcesses(querySpec?: QuerySpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<TransferProcess>>>;
    public queryAllTransferProcesses(querySpec?: QuerySpec): Observable<any> {
      return from(this.transferProcessService.queryAll(querySpec))
    }

    public getToken(transferProcess: TransferProcess): Observable<EdrDataAddress> {
      console.log(transferProcess.id)
      return this.http.get<EdrDataAddress>(
        `${this.appConfigService.config?.managementApiUrl}/v3/edrs/${transferProcess.id}/dataaddress`);
    }

    public getData(token: string, endpoint: string, pathParams?: string[], queryParams?: { [key: string]: string }): Observable<any> {
      const headers = new HttpHeaders({
        'Authorization': token,
        'X-API-Key': this.appConfigService.config?.apiKey || ''
      });

      console.log(pathParams);
      console.log(queryParams);
      
      const context = new HttpContext().set(SKIP_KEYCLOAK_INTERCEPTOR, true);
      
      // Construir el endpoint con parámetros de path
      let finalEndpoint = endpoint;
      if (pathParams && pathParams.length > 0) {
        // Agregar cada valor del path al final del endpoint
        const pathSuffix = pathParams.map(value => encodeURIComponent(value)).join('/');
        finalEndpoint = `${finalEndpoint}/${pathSuffix}`;
      }
      
      // Construir query params
      let queryString = '';
      if (queryParams && Object.keys(queryParams).length > 0) {
        const params = new URLSearchParams();
        Object.entries(queryParams).forEach(([key, value]) => {
          params.append(key, value);
        });
        queryString = `?${params.toString()}`;
      }
      
      const urlWithParams = `${finalEndpoint}${queryString}`;

      console.log("Final URL:", urlWithParams);
      
      return this.http.get(urlWithParams, { headers, context });
    }
}
